export enum APIErrorEnum {
  INVALID_GRANT = "invalid_grant",
}

export type FetchErrorType = {
  status: number;
  message: string;
};
